<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-prop-type-constructor
    id: {type: String | Number, default: null},
    templateFile: {type: String, default: null},
    name: {type: String},
    mode: {type: String, default: 'upload'}
  },
  data: (props) => ({
    isLoading: false,
    alias: props.name ? props.name : '',
    file: props.templateFile ? props.templateFile : null,
    error: null,
    isFormValid: true,
    isSuccessIndicatorVisible: false
  }),
  methods: {
    setFormValidity(isValid, errorMessage) {
      this.isFormValid = isValid
      return errorMessage
    },
    uploadStationery() {
      this.error = null
      this.isLoading = true

      let formData = new FormData()
      this.$props.templateFile === null && formData.append('file', this.file)
      formData.append('name', this.alias)

      if (this.$store.getters.selectedOrganization.OrganizationId) {
        formData.append('organizationId', this.$store.getters.selectedOrganization.OrganizationId)
      }

      if (this.$props.mode === 'upload') {
        return this.$coverSheetService
            .uploadCoverSheet(formData)
            .then((response) => {
              this.isSuccessIndicatorVisible = true
              this.isLoading = true
              setTimeout(() => {
                this.$refs.coverSheetTemplateUploader.resetValidation()
                this.alias = ''
                this.file = null
                this.isSuccessIndicatorVisible = false
                this.isLoading = false
                this.$emit('stationery-uploaded', response)
              }, 2000)
            })
            .catch((error) => {
              this.isLoading = false
              this.error = this.$t('component.documentValidation.coverSheetTemplateUploader.upload.error') // display a list of suggestions?
              console.error('Upload Coversheet: ', error)
            })
      } else {
        return this.$coverSheetService
            .updateCoverSheet(formData, this?.$props?.id)
            .then((response) => {
              this.isSuccessIndicatorVisible = true
              this.isLoading = true
              setTimeout(() => {
                this.$refs.coverSheetTemplateUploader.resetValidation()
                this.alias = ''
                this.file = null
                this.isSuccessIndicatorVisible = false
                this.isLoading = false
                this.$emit('stationery-uploaded', response)
              }, 2000)
            })
            .catch((error) => {
              this.isLoading = false
              this.error = this.$t('component.documentValidation.coverSheetTemplateUploader.update.error') // display a list of suggestions?
              console.error('Upload Coversheet: ', error)
            })
      }

    }
  }
}
</script>
<template>
  <v-card-text>
    <v-row v-if="error">
      <v-col>
        <v-alert type="error">
          {{ error }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
          <span class="text-body-2">
            {{ $t('component.documentValidation.coverSheetTemplateUploader.upload.description') }}
          </span>
      </v-col>
    </v-row>
    <v-form
      ref="coverSheetTemplateUploader"
      v-model="isFormValid"
      name="coverSheetTemplateUploader"
      @submit.prevent>
      <v-row v-if="!isSuccessIndicatorVisible" class="my-5">
        <v-col>
          <div
            v-if="templateFile"
            style="background-color:#f9f9f9;padding:18px;">
            <div
              :style="`background:url(${templateFile}) no-repeat center center;`"
              class="card-image-preview">
              <v-icon
                style="position:absolute;top:0;right:0;"
                @click="templateFile = null">mdi-close</v-icon>
            </div>
          </div>
          <v-file-input
            v-else
            v-model="file"
            :label="$t('component.documentValidation.coverSheetTemplateUploader.file.label')"
            truncate-length="75"
            accept="application/pdf"
            prepend-icon="mdi-file-pdf-box"
            required
            :rules="[v => !!v ||
            setFormValidity(false, $t('component.documentValidation.coverSheetTemplateUploader.file.required'))]">
          </v-file-input>
        </v-col>
      </v-row>
      <v-row v-if="!isSuccessIndicatorVisible">
        <v-col>
          <v-text-field
            v-model="alias"
            outlined
            clearable
            :label="$t('component.documentValidation.coverSheetTemplateUploader.text.required')"
            :rules="[v => !!v || setFormValidity(false, $t('component.documentValidation.coverSheetTemplateUploader.text.required'))]"
            required >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="isSuccessIndicatorVisible">
        <v-col>
          <v-alert type="success">
            {{ $t('component.documentValidation.coverSheetTemplateUploader.success') }}
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            color="yellow"
            block
            :disabled="!isFormValid"
            :loading="isLoading"
            @click="uploadStationery">
            <v-icon>mdi-upload</v-icon>
            {{ $props.id ? $t('button.update.template')
            : $t('button.upload.template') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card-text>
</template>
<style scoped>
.card-image-preview {
  position:relative;
  min-height: 40vh !important;
  background-size: contain !important;
  width: 100% !important;
}
</style>
